import { breakpoints } from "@repo/fika-design-system/breakpoints"
import { createMediaQuery } from "@solid-primitives/media"
import { createSignal, onCleanup } from "solid-js"

const KEYBOARD_HEIGHT_THRESHOLD = 150

// This is the biggest hack ever to detect if the virtual keyboard is open on mobile devices
// Deprecate once Firefox and Safari implement the VirtualKeyboard API
export function useVirtualKeyboard() {
  const [isKeyboardOpen, setIsKeyboardOpen] = createSignal(false)
  const [viewportHeight, setViewportHeight] = createSignal<number>()
  const isMobile = createMediaQuery(breakpoints.l)

  const vv = window.visualViewport
  if (vv) {
    let rafId: number | undefined

    function check() {
      rafId = undefined
      const diff = window.innerHeight - vv!.height
      const open = diff > KEYBOARD_HEIGHT_THRESHOLD
      setIsKeyboardOpen(open)
      setViewportHeight(open ? vv!.height : undefined)
    }

    function onResize() {
      if (rafId !== undefined) return
      rafId = requestAnimationFrame(check)
    }

    vv.addEventListener("resize", onResize)
    onCleanup(() => {
      vv.removeEventListener("resize", onResize)
      if (rafId !== undefined) cancelAnimationFrame(rafId)
    })
  }

  const isMobileKeyboardOpen = () => isMobile() && isKeyboardOpen()

  return {
    isKeyboardOpen,
    isMobileKeyboardOpen,
    isMobile,
    viewportHeight,
  } as const
}
